import React, { FC } from 'react'

import { styled } from '@mui/material'

import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'

import { useLocalizedText } from '../../context/Localization/localizationHooks'
import { LocalizedText } from '../../context/Localization/LocalizationTypes'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { addSubCondition } from '../../store/groupConditionsSlice'
import { useViewModeReadOnly } from '../../context/ViewMode/viewModeHooks'

const RootContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'start',
    marginTop: '24px',
}))

export const AddSubConditionButtonContainer = styled(Button)(() => ({
    textTransform: 'capitalize',
    fontFamily: 'Open Sans',
}))

export interface AddSubConditionProps {
    index: number
}

const AddSubCondition: FC<AddSubConditionProps> = (props) => {
    const ADD_NEW_SUBCONDITION = useLocalizedText(LocalizedText.AddNewSubCondition)
    const isReadOnly = useViewModeReadOnly()
    const dispatch = useAppDispatch()

    return (
        <RootContainer>
            <AddSubConditionButtonContainer disabled={isReadOnly} variant="outlined" startIcon={<AddIcon />} onClick={() => dispatch(addSubCondition({ groupIndex: props.index }))}>
                {ADD_NEW_SUBCONDITION}
            </AddSubConditionButtonContainer>
        </RootContainer>
    )
}

export default AddSubCondition